/*
  NOTE: This helper exports a custom validation rule for the Vee Validate plugin:
  https://vee-validate.logaretm.com/v4/guide/global-validators
*/

import detectCreditCardType from 'credit-card-type';



const validateCardType = (value) => {
  if (value == null) return 'This card network isn\'t supported.';
  const allowedCardTypes = ['visa', 'american-express', 'discover', 'mastercard', 'jcb', 'diners-club'];
  const cardType = detectCreditCardType(value)[0];

  if (cardType && allowedCardTypes.indexOf(cardType.type) > -1) {
    return true;
  }

  return 'This card network isn\'t supported.';
};



export default validateCardType;
